module.exports = __webpack_public_path__ + "img/MikeMay.01d4335a.jpeg";